import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { apiUrls } from '../../../common/api_urls/api_urls';
import { catchError, tap, throwError } from 'rxjs';
import { AuthService } from '../../../services/auth.service';
import { headers } from '../../../common/headers';

const header = new HttpHeaders({ [headers.lookupHeader]: 'true' });

@Injectable({
  providedIn: 'root',
})
export class ForgetPasswordService {
  public http = inject(HttpClient);
  public authService = inject(AuthService);
  constructor() {}
  forgetPassword(data: any) {
    var bodyData = {
      username: data.email,
    };
    return this.http
      .post(apiUrls.authentication.forgetPassword, bodyData, {
        headers: header,
      })
      .pipe(
        tap((data: any) => {
          this.authService.saveSessionByKey(
            this.authService.emailKey,
            bodyData.username,
          );
        }),
        catchError((error) => {
          return throwError(() => error);
        }),
      );
  }
}
